<template>
  <div>
    <div :class="[name=='Login' ? 'login_lang':'lang-title']" @click.stop="_isOpen(1)">
      <span>{{languageTitle}}
        <img src="../../assets/img/CN.png" class="lang-icon" v-if="name!='Login' && language=='zh_CN'"/>
        <img src="../../assets/img/MM.png" class="lang-icon" v-if="name!='Login' && language=='mm_MY'"/>
        <img src="../../assets/img/EN.png" class="lang-icon" v-if="name!='Login' && language=='en_WW'"/>
      </span>
      <img src="../../assets/img/arrow-down.png"/>
      <div :class="[name=='Login' ? 'langClose':'langindexClose']" v-if="isLang && name!='Login'">
        <div v-for="item in lang" :class="{'langCloseColor':language==item.type}" @click.stop="_isOpen(2,item.type)">{{item.title}}
          <img src="../../assets/img/CN.png" class="lang-icon" v-if="item.id==1"/>
          <img src="../../assets/img/MM.png" class="lang-icon" v-else-if="item.id==2"/>
          <img src="../../assets/img/EN.png" class="lang-icon" v-else-if="item.id==3"/>
        </div>
      </div>
    </div>
    <div :class="[name=='Login' ? 'langClose':'langindexClose']" v-if="isLang && name=='Login'">
      <div v-for="item in lang" :class="{'langCloseColor':language==item.type}" @click.stop="_isOpen(2,item.type)">
        <img src="../../assets/img/CN.png" v-if="item.id==1"/>
        <img src="../../assets/img/MM.png" v-else-if="item.id==2"/>
        <img src="../../assets/img/EN.png" v-else-if="item.id==3"/>
        {{item.title}}
      </div>
    </div>

  </div>

</template>

<script>
    export default {
        name: "lang",
      data(){
          return{
            lang:[
              {"title":this.$t('login.zw'),'type':'zh_CN','id':'1'},
              {"title":this.$t('login.mw'),'type':'mm_MY','id':'2'},
              {"title":this.$t('login.en'),'type':'en_WW','id':'3'},
            ],
            language:'',
            languageTitle:'',
            isLang:false,
          }
      },
      props:['name'],
      created:function(){
          let _self=this;
          _self._locales();
      },
      methods:{
        _locales:function(){
          let lang = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'mm_MY';
          this.$i18n.locale=lang;
          this.language=lang;
          if(lang=='mm_MY'){
            this.languageTitle=this.$t('login.mw')
          }else if(lang=='zh_CN'){
            this.languageTitle=this.$t('login.zw')
          }else if(lang=='en_WW'){
            this.languageTitle=this.$t('login.en')
          }
        },
        _isOpen:function (m,lang) {
          let _self=this;
          if(m==1){
            if(_self.isLang==true){
              _self.isLang=false;
            }else {
              _self.isLang=true;
            }

          }else if(m==2){
            localStorage.setItem('locale',lang);
            console.log(lang)
            _self.isLang=false;
            _self._locales();
            window.location.reload();
          }
        },
      }
    }
</script>

<style scoped>
  .login_lang{
    display: flex;
    padding: 0 10px;
    font-size: 16px;
    align-items: center;
    cursor: pointer;
    position: relative;

  }
  .lang-title{
    position: relative;
    width: 100%;
    display: flex;
    min-width: 100px !important;
    padding:0 10px;
    height: 45px;
    align-items: center;
    color: #EDD4AC;
    font-weight: bold;
  }
  .login_lang img,.lang-title img{
    width: 25px;
    height: auto;
    margin-left: 5px;
    vertical-align: middle;
  }
  .lang-icon{
    width: 30px!important;
    height: 30px !important;
    margin-left: 10px!important;
  }
  .langClose{
    position: absolute;
    z-index: 9;
    right: 10px;
    top: 35px;
    background-color: #ffffff;
    border-radius: 5px;
    min-width: 150px;

  }
  .langindexClose{
    display: block;
    flex-direction: column;
    flex-wrap: wrap;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 45px;
    z-index: 99;
    height: auto !important;
    background-color: #09141F;
    box-shadow: 0 3px 3px 0 rgba(108,131,172,0.5);
  }
  .langClose div,.langindexClose div{
    display: flex;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding: 15px 0;
    font-size: 16px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  }
  .langClose div img,.langindexClose div img{
    width: 30px;
    height: auto;
    margin-right: 5px;
  }

  .langindexClose div{
    border-right: 1px solid rgba(45, 70, 95, 0.3);
    position: relative;
    width: 100%;
    min-width: 100px !important;
    align-items: center;
    color: #EDD4AC;
    font-weight: bold;
    padding: 10px 0 !important;
    display: flex!important;
    justify-content: center;
  }
  .langCloseColor{
    background-color: #DCDCDC;
  }
  .langindexClose .langCloseColor{
    background-image: linear-gradient(-180deg, #0C1117 0%, #162C3F 100%)!important;
  }
  .langClose div:first-child{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .langClose div:last-child{
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/navs/lang.vue